<div class="agview">
    <img src="assets\agview-connect\agview-connect.png" draggable="false" alt="">

    <app-dialog-configuracao-parametro class="dialog-configuracao-parametro"
        *ngIf="dialogVisivel && !dialogLoginVisivel" @fadeInOut></app-dialog-configuracao-parametro>
    <app-dialog-login class="dialog-login" *ngIf="dialogLoginVisivel && !dialogVisivel" @fadeInOut
        (fechar)="dialogLoginVisivel = false" (trocarTela)="irParaTelaConfiguracaoLicenca()"></app-dialog-login>

    <div class="agview-conteudo">
        <app-navbar *ngIf="!telaLicenca" (trocarTela)="voltarTelaConfigsGerais()"></app-navbar>
        <div class="main-container" [class.h-100]="telaLicenca">
            <ng-container #container></ng-container>
        </div>
    </div>
</div>